<template>
  <span>{{filamentText}}</span>
</template>

<script>
  export default {
    name: 'job-filament',
    props: ['filament'],
    computed: {
      filamentText() {
        const filament = parseFloat(this.filament).toFixed(2);
        if (filament === 'NaN') {
          return '';
        }

        return filament + this.$t('measure.shortcut.gram');
      }
    }
  }
</script>